// extracted by mini-css-extract-plugin
export default {"conatcts":"Contacts_conatcts__s-jSm","conatcts__socials":"Contacts_conatcts__socials__eWqnx","conatcts__socials__list":"Contacts_conatcts__socials__list__+c53N"};